import Vue from 'vue'
import VueRouter from 'vue-router'
//auth
import login from '../views/auth/login.vue'
import resetPassword from '../views/auth/resetPassword.vue'
import register from '../views/auth/register.vue'

//main
import Home from '../views/Home.vue'
import POS from '../views/POS.vue'
//sales
import sales from '../views/sales.vue'
import saleDetail from '../views/sales/saleDetail'
//orders
import orders from '../views/orders.vue'
import expenses from '../views/expenses.vue'
//billing
import billing from '../views/billing.vue'
//debtors
import debtors from '../views/debtors/debtors.vue'
import debtorDetail from '../views/debtors/debtorDetail.vue'


import customers from '../views/customers.vue'
import purchases from '../views/purchases.vue'
import receivePurchase from '../views/receivePurchase.vue'

import products from '../views/products/products.vue'
import productDetail from '../views/products/productDetail.vue'
//stock management
import stock from '../views/stock/stock.vue'
import stockDetail from '../views/stock/stockDetail.vue'
import stocktake from '../views/stock/subviews/stocktake.vue'
//Config
import unitsOfMeasure from '../views/unitsOfMeasure.vue'
import locations from '../views/locations.vue'
import businessDetails from '../views/businessDetails.vue'
//reports
import reports from '../views/reports/reports.vue'
// sales reports
import  salesPerPaymentMethod from  '../views/reports/sales/salesPerPaymentMethod.vue'
import  salesPerProduct from  '../views/reports/sales/salesPerProduct.vue'
import  salesPerCustomer from  '../views/reports/sales/salesPerCustomer.vue'
import  salesPerUser from  '../views/reports/sales/salesPerUser.vue'
import  salesPerLocation from  '../views/reports/sales/salesPerLocation.vue'
import  mpesaSalesReport from  '../views/reports/sales/mpesaSales.vue'
//purchases reports
import purchasesPerSupplier from '../views/reports/purchases/purchasesPerSupplier'
import purchasesPerProduct from '../views/reports/purchases/purchasesPerProduct'
//expenses reports
import expensesPerType from '../views/reports/expenses/expensesPerType'
import expensesPerLocation from '../views/reports/expenses/expensesPerLocation'
//customers reports
import customersPerUser from '../views/reports/customers/customersPerUser'
import customersByUser from '../views/reports/customers/customersByUser'
// product reports
import profitsPerSale from '../views/reports/profits/profitsPerSale'
import profitsPerProduct from '../views/reports/profits/profitsPerProduct'
import profitsPerUser from '../views/reports/profits/profitsPerUser'
import profitsPerLocation from '../views/reports/profits/profitsPerLocation'
import profitsPerCustomer from '../views/reports/profits/profitsPerCustomer'
//marginal reports
import marginsPerUser from '../views/reports/margins/marginsPerUser'


//system users.
import users from '../views/users'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/on-boarding',
      name: 'on-boarding',
      component: () => import('../views/onBoarding.vue')
    },
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: {
		group: 'auth'
		}
	},
	{
		path: '/reset-password',
		name: 'reset-password',
		component: resetPassword,
		meta: {
		group: 'auth'
		}
	},
	{
		path: '/register',
		name: 'register',
		component: register,
		meta: {
		group: 'auth'
		}
	},
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
		group: 'home'
		}
	},
	{
		path: '/pos',
		name: 'pos',
		component: POS,
		meta: {
			group: 'pos'
		}
	},
	{
		path: '/sales',
		name: 'sales',
		component: sales,
		meta: {
		group: 'sales'
		}
	},
	{
		path: '/sale/:sale_id',
		name: 'saleDetail',
		component: saleDetail,
		props:true,
		meta: {
		group: 'sales'
		}
	},
	{
		path: '/orders',
		name: 'orders',
		component: orders,
		meta: {
		group: 'orders'
		}
	},
	{
		path: '/expenses',
		name: 'expenses',
		component: expenses,
		meta: {
		group: 'expenses'
		}
	},
	//debtors
	{
		path: '/debtors',
		name: 'debtors',
		component: debtors,
		meta: {
		group: 'debtors'
		}
	},
	{
		path: '/debtor-detail',
		name: 'debtorDetail',
		component: debtorDetail,
		meta: {
		group: 'debtors'
		}
	},
	{
		path: '/customers',
		name: 'customers',
		component: customers,
		meta: {
		group: 'customers'
		}
	},
	{
		path: '/purchases',
		name: 'purchases',
		component: purchases,
		meta: {
			group: 'purchases'
		}
	},
	{
		path: '/receive-purchase',
		name: 'receivePurchase',
		component:receivePurchase,
		meta: {
			group: 'purchases'
		}
	},
	{
		path: '/products',
		name: 'products',
		component: products,
		meta: {
		group: 'products'
		}
	},
	{
		path: '/product-detail/:product_id',
		name: 'productDetail',
		component: productDetail,
		props:true,
		meta: {
		group: 'products'
		}
	},
	{
		path: '/stock',
		name: 'stock',
		component: stock,
		props:true,
		meta: {
		group: 'stock'
		}
	},
	{
		path: '/stock-detail',
		name: 'stockDetail',
		component: stockDetail,
		props:true,
		meta: {
		group: 'stock'
		}
	},
	{
		path: '/stock-take',
		name: 'stocktake',
		component: stocktake,
		meta: {
		group: 'stock'
		}
	},
	//CONFIG
	{
		path: '/locations',
		name: 'locations',
		component: locations,
		meta: {
		group: 'locations'
		}
	},
	{
		path: '/units-of-measure',
		name: 'unitsOfMeasure',
		component: unitsOfMeasure,
		meta: {
		group: 'unitsOfMeasure'
		}
	},
	{
		path: '/business-details',
		name: 'businessDetails',
		component: businessDetails,
		meta: {
		group: 'businessDetails'
		}
	},
	{
		path: '/reports',
		name: 'reports',
		component: reports,
		meta: {
		group: 'reports'
		}
	},
		// REPORTS
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
	{
		path: '/sales-per-payment-method',
		name: 'salesPerPaymentMethod',
		component: salesPerPaymentMethod,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/sales-per-product',
		name: 'salesPerProduct',
		component: salesPerProduct,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/sales-per-customer',
		name: 'salesPerCustomer',
		component: salesPerCustomer,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/sales-per-user',
		name: 'salesPerUser',
		component: salesPerUser,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/sales-per-location',
		name: 'salesPerLocation',
		component: salesPerLocation,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/mpesa-sales-report',
		name: 'mpesaSalesReport',
		component: mpesaSalesReport,
		meta: {
		group: 'reports'
		}
	},
	// purchase reports
	{
		path: '/purchase-per-supplier',
		name: 'purchasePerSupplier',
		component: purchasesPerSupplier,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/purchase-per-product',
		name: 'purchasePerProduct',
		component: purchasesPerProduct,
		meta: {
		group: 'reports'
		}
	},
	//expenses reports
	{
		path: '/expenses-per-type',
		name: 'expensesPerType',
		component: expensesPerType,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/expenses-per-location',
		name: 'expensesPerLocation',
		component: expensesPerLocation,
		meta: {
		group: 'reports'
		}
	},
	//customers
	{
		path: '/customers-per-user',
		name: 'customersPerUser',
		component: customersPerUser,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/customers-by-user',
		name: 'customersByUser',
		component: customersByUser,
		meta: {
		group: 'reports'
		}
	},
	//profits
	{
		path: '/profits-per-sale',
		name: 'profitsPerSale',
		component: profitsPerSale,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/profits-per-product',
		name: 'profitsPerProduct',
		component: profitsPerProduct,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/profits-per-user',
		name: 'profitsPerUser',
		component: profitsPerUser,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/profits-per-location',
		name: 'profitsPerLocation',
		component: profitsPerLocation,
		meta: {
		group: 'reports'
		}
	},
	{
		path: '/profits-per-customer',
		name: 'profitsPerCustomer',
		component: profitsPerCustomer,
		meta: {
		group: 'reports'
		}
	},
	//margins
	{
		path: '/margins-per-user',
		name: 'marginsPerUser',
		component: marginsPerUser,
		meta: {
		group: 'reports'
		}
	},

	{
		path: '/users',
		name: 'users',
		component: users,
		meta: {
		group: 'users'
		}
	},
	
	{
		path: '/billing',
		name: 'billing',
		component: billing,
		meta: {
		group: 'billing'
		}
	},
]

const router = new VueRouter({
  routes
})
// authenticate route before entry
 function isAuthenticated(){
	if ("auth_token" in localStorage) {
		return true
	} else {
		return false
	}
}
//check if new user

router.beforeEach((to, from, next) => {
	//authenticate every route
	//exempt register and login view from authentication
	if ((
		to.name !== 'login'
		&& to.name !== 'on-boarding'
		&& to.name !== "register"
		&& to.name !== "reset-password"
		)
		&& ! isAuthenticated()){
		next({ name: 'login' })
	}
	else{
		next()
	}
})

export default router
